import { Icon } from 'common/icon';
import { Button } from 'common/new-button';
import { Anchor } from 'constants/anchors';
import { ISlot } from 'constants/types';
import { useRouter } from 'next/router';
import { useState } from 'react';
import styles from './styles.module.css';

export const PlayBlock = ({ slot }: { slot: ISlot }) => {
  const router = useRouter();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const reloadIframe = () => {
    // implement reload logic if needed
  };

  if (!slot.playForFreeLink?.length || slot.playForFreeLink === 'none') {
    return null;
  }

  return (
    <div>
      <div id={Anchor.slot.demo} />

      <div className={styles.container}>
        <div className={styles.leftSection}>
          <h2 className={styles.title}>Play Name slots Online Slot for Free</h2>
        </div>
        <div className={styles.rightSection} onClick={reloadIframe}>
          <div className={styles.reloadIcon}>
            <Icon.RestartSecond />
          </div>
          <div className={styles.reloadText}>Refresh Game Credit</div>
        </div>
      </div>

      <div className={styles.playContainer}>
        <div className={styles.buttons}>
          <Button
            className={styles.forFreeButton}
            icon={<Icon.Play fill="#121212" backgroundFill={null} />}
            text={'Play demo for free'}
            onClick={() => setIsModalOpen(true)}
          />
          <Button
            className={styles.forRealMoney}
            icon={<Icon.Dollar fill="#121212" />}
            text={'Play for real money'}
            onClick={() => {
              router.replace(`#${Anchor.slot.forMoney}`);
            }}
          />
        </div>
      </div>

      {isModalOpen && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <button
              className={styles.close}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                setIsModalOpen(false);
              }}
            >
              <Icon.CloseSecond fill="#000" />
            </button>

            <iframe
              width="100%"
              height="100%"
              src={`${slot.playForFreeLink!}`}
              allow="autoplay; fullscreen"
              scrolling="auto"
            />
          </div>
        </div>
      )}
    </div>
  );
};
